import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useCallback, useEffect, useState } from "react";
import moment from "moment";
import { TwoRowCell } from "../../../common/cell.component";
import { RequestStatus } from "./RequestStatus";
import { RequestStatusEnum } from "../types";
import RejectRequestModal from "./RejectRequestModal";
import SolutionsResult from "./SolutionsResult";
import EditSolutionRoles from "./EditSolutionRoles";
import { approveUserRequest } from "../../../../api/accountSetting.api";
import { setUserTypeSubscriptionsStatus } from "../../hooks/useSolutions";
export function UserRequestItem(props) {
  var _request$reviewerComm;

  var prefix = props.prefix,
      translate = props.translate,
      request = props.request,
      setLoading = props.setLoading,
      onRefresh = props.onRefresh,
      refreshRequestListComponent = props.refreshRequestListComponent;
  var componentClass = "".concat(prefix, "-user-request-modal");

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isRejectModalOpen = _useState2[0],
      setRejectModalOpen = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      processed = _useState4[0],
      setProcessed = _useState4[1];

  var _useState5 = useState({}),
      _useState6 = _slicedToArray(_useState5, 2),
      processedMsg = _useState6[0],
      setProcessedMsg = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      showValidation = _useState8[0],
      setShowValidation = _useState8[1];

  var _useState9 = useState({
    solutions: [],
    solutionValid: false
  }),
      _useState10 = _slicedToArray(_useState9, 2),
      result = _useState10[0],
      setResult = _useState10[1]; // Update the subscription selected status.


  useEffect(function () {
    var selectedSubscriptionIds = [];
    result.solutions.forEach(function (solution) {
      var _solution$subscriptio;

      if ((_solution$subscriptio = solution.subscription) !== null && _solution$subscriptio !== void 0 && _solution$subscriptio.objectID) {
        var _solution$subscriptio2;

        selectedSubscriptionIds.push((_solution$subscriptio2 = solution.subscription) === null || _solution$subscriptio2 === void 0 ? void 0 : _solution$subscriptio2.objectID);
      }
    });
    setUserTypeSubscriptionsStatus(selectedSubscriptionIds, true);
    refreshRequestListComponent();
    return function () {
      setUserTypeSubscriptionsStatus(selectedSubscriptionIds, false);
      refreshRequestListComponent();
    };
  }, [refreshRequestListComponent, result.solutions]);
  var onSolutionRoleChange = useCallback(function (solutions, solutionValid) {
    setResult({
      solutions: solutions,
      solutionValid: solutionValid
    });
  }, []);

  var handleApprove = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var data, _error$response, _error$response2, errorStatus, message, _processedMsg, _message$data;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setShowValidation(true);

              if (result.solutionValid) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              _context.prev = 3;
              setLoading(true);
              data = composeResult(request, result.solutions);
              _context.next = 8;
              return approveUserRequest(data);

            case 8:
              onRefresh();
              _context.next = 19;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](3);
              errorStatus = _context.t0 === null || _context.t0 === void 0 ? void 0 : (_error$response = _context.t0.response) === null || _error$response === void 0 ? void 0 : _error$response.status;
              message = _context.t0 === null || _context.t0 === void 0 ? void 0 : (_error$response2 = _context.t0.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.data;
              _processedMsg = {
                status: '',
                message: message
              };

              if (errorStatus === 400) {
                if (message.errorCode === '2x4') {
                  _processedMsg.status = (_message$data = message.data) === null || _message$data === void 0 ? void 0 : _message$data.status;
                }

                if (message.errorCode === '2x3') {
                  _processedMsg.status = RequestStatusEnum.threshold;
                }
              }

              setProcessed(true);
              setProcessedMsg(_processedMsg);

            case 19:
              _context.prev = 19;
              setLoading(false);
              return _context.finish(19);

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 11, 19, 22]]);
    }));

    return function handleApprove() {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(componentClass, "-list-item")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(componentClass, "-list-column ").concat(componentClass, "-list-name")
  }, /*#__PURE__*/React.createElement(TwoRowCell, {
    topContent: "".concat(request.surname, " ").concat(request.givenName),
    bottomContent: request.email
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(componentClass, "-list-column ").concat(componentClass, "-list-requestor")
  }, /*#__PURE__*/React.createElement(TwoRowCell, {
    topContent: request.creatorFullName,
    bottomContent: request.creatorEmail
  }), /*#__PURE__*/React.createElement("span", null, moment.utc(request.createdDate).local().format("YYYY-MM-DD h:mm:ss A"))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(componentClass, "-list-column ").concat(componentClass, "-list-solutions")
  }, request.status === RequestStatusEnum.solved ? '' : request.status === RequestStatusEnum.pending ? /*#__PURE__*/React.createElement(EditSolutionRoles, {
    translate: translate,
    prefix: prefix,
    request: request,
    showValidation: showValidation,
    onSolutionRoleChange: onSolutionRoleChange
  }) : /*#__PURE__*/React.createElement(SolutionsResult, {
    request: request,
    translate: translate,
    prefix: prefix
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(componentClass, "-list-column ").concat(componentClass, "-list-status")
  }, /*#__PURE__*/React.createElement(RequestStatus, {
    prefix: prefix,
    translate: translate,
    isProcessed: processed,
    processedMsg: processedMsg,
    request: request,
    canApprove: result.solutions.length > 0,
    onApprove: handleApprove,
    onReject: function onReject() {
      setRejectModalOpen(true);
    }
  })), request.status === RequestStatusEnum.rejected && /*#__PURE__*/React.createElement("div", {
    className: "".concat(componentClass, "-list-reject-reason")
  }, (_request$reviewerComm = request.reviewerComment) !== null && _request$reviewerComm !== void 0 ? _request$reviewerComm : ''), isRejectModalOpen && /*#__PURE__*/React.createElement(RejectRequestModal, {
    prefix: prefix,
    translate: translate,
    isOpen: isRejectModalOpen // setLoading={setLoading}
    ,
    request: request,
    onToggle: function onToggle() {
      setRejectModalOpen(function (prev) {
        return !prev;
      });
    },
    onClose: function onClose() {
      setRejectModalOpen(false);
    },
    setProcessed: setProcessed,
    setProcessedMsg: setProcessedMsg,
    onRejectedSuccess: function onRejectedSuccess() {
      onRefresh();
    }
  })));
}

function composeResult(originalRequest, solutionResult) {
  var requestedSolutions = solutionResult.map(function (solution) {
    var _solution$subscriptio5, _solution$subscriptio6;

    var isRemained = solution.isInitialSolution === true;

    if (isRemained) {
      var _solution$subscriptio3, _solution$subscriptio4;

      var originalSolution = originalRequest.requestedSolutions.find(function (s) {
        return s.solutionId === solution.id;
      });
      return _objectSpread(_objectSpread({}, originalSolution), {}, {
        finalSolutionRoles: [{
          roleId: solution.roles[0].id,
          roleName: solution.roles[0].displayName,
          subscription: (_solution$subscriptio3 = (_solution$subscriptio4 = solution.subscription) === null || _solution$subscriptio4 === void 0 ? void 0 : _solution$subscriptio4.objectID) !== null && _solution$subscriptio3 !== void 0 ? _solution$subscriptio3 : ''
        }]
      });
    }

    return {
      solutionId: solution.id,
      solutionName: solution.name,
      finalSolutionRoles: [{
        roleId: solution.roles[0].id,
        roleName: solution.roles[0].displayName,
        subscription: (_solution$subscriptio5 = (_solution$subscriptio6 = solution.subscription) === null || _solution$subscriptio6 === void 0 ? void 0 : _solution$subscriptio6.objectID) !== null && _solution$subscriptio5 !== void 0 ? _solution$subscriptio5 : ''
      }]
    };
  });
  return _objectSpread(_objectSpread({}, originalRequest), {}, {
    requestedSolutions: requestedSolutions
  });
}